/**
 * @desc 发运订单
 */
const URL = "/rantion-walmart";
import http, { updateResponse } from "@/http";
export function request(body: defs.walmart.WalmartOrderShippingDto, options?: any) {
  return updateResponse(
    http(URL + `/walmart/orderShipping`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
